import { render, staticRenderFns } from "./lineasProductos.vue?vue&type=template&id=04d4c8b3&scoped=true"
import script from "./lineasProductos.vue?vue&type=script&lang=js"
export * from "./lineasProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4c8b3",
  null
  
)

export default component.exports